/**
 * commissions-lookbook.js — Lightbox per la pagina "Ispirati & Crea".
 *
 * Standalone (caricato con <script defer> dalla sezione, nessuna dipendenza).
 * Progressive enhancement: senza JS le card restano informazioni statiche.
 * Al click su un pezzo apre una galleria a schermo con tutte le sue foto +
 * titolo, tipo/materiale e descrizione. Frecce prev/next, swipe, Esc / backdrop / ×
 * per chiudere, focus trap e gestione del focus per l'accessibilità.
 * In più: deep link #pezzo-<slug> condivisibile e filtri client-side per
 * tipo/materiale sulla griglia. Il CTA verso i contatti è un link statico:
 * il form non legge parametri, quindi non ne aggiungiamo di decorativi.
 */
(function () {
  'use strict';

  function initSection(section) {
    if (section.__commissionsInit) return;
    section.__commissionsInit = true;

    var lb = section.querySelector('[data-clightbox]');
    if (!lb) return;

    var imgEl = lb.querySelector('[data-cl-img]');
    var titleEl = lb.querySelector('[data-cl-title]');
    var metaEl = lb.querySelector('[data-cl-meta]');
    var descEl = lb.querySelector('[data-cl-desc]');
    var counterEl = lb.querySelector('[data-cl-counter]');
    var prevBtn = lb.querySelector('[data-cl-prev]');
    var nextBtn = lb.querySelector('[data-cl-next]');
    var closeBtn = lb.querySelector('[data-cl-close]');
    var infoEl = lb.querySelector('.clightbox__info');
    if (!imgEl || !titleEl || !metaEl || !descEl || !counterEl || !prevBtn || !nextBtn || !closeBtn) return;

    var images = [];
    var index = 0;
    var lastFocus = null;

    function render() {
      var multi = images.length > 1;
      if (images.length) {
        imgEl.src = images[index];
        imgEl.hidden = false;
        // Precarico la foto successiva: senza, la prima navigazione mostra un frame vuoto.
        if (multi) new Image().src = images[(index + 1) % images.length];
      } else {
        imgEl.removeAttribute('src');
        imgEl.hidden = true;
      }
      counterEl.textContent = multi ? (index + 1) + ' / ' + images.length : '';
      counterEl.hidden = !multi;
      prevBtn.hidden = !multi;
      nextBtn.hidden = !multi;
    }

    function go(delta) {
      if (images.length < 2) return;
      index = (index + delta + images.length) % images.length;
      render();
    }

    function open(btn) {
      lastFocus = btn;
      images = (btn.getAttribute('data-images') || '').split('|').filter(Boolean);
      index = 0;

      var title = btn.getAttribute('data-title') || '';
      titleEl.textContent = title;
      titleEl.hidden = !title;
      imgEl.alt = title;

      var meta = btn.getAttribute('data-meta') || '';
      metaEl.textContent = meta;
      metaEl.hidden = !meta;

      var descNode = btn.querySelector('.ccard__desc');
      var desc = descNode ? descNode.textContent.trim() : '';
      descEl.textContent = desc;
      descEl.hidden = !desc;

      render();
      lb.hidden = false;
      if (infoEl) infoEl.scrollTop = 0;
      document.body.classList.add('clightbox-open');
      document.addEventListener('keydown', onKey);
      closeBtn.focus();
      setHash(btn.getAttribute('data-slug'));
    }

    function close() {
      lb.hidden = true;
      document.body.classList.remove('clightbox-open');
      document.removeEventListener('keydown', onKey);
      setHash('');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    // Ogni pezzo diventa condivisibile: .../crea-il-tuo-gioiello-unico#pezzo-anello-sole
    function setHash(slug) {
      if (!window.history || !history.replaceState) return;
      // encode in scrittura / decode in lettura: la coppia deve restare simmetrica
      var url = slug ? location.pathname + location.search + '#pezzo-' + encodeURIComponent(slug)
                     : location.pathname + location.search;
      try { history.replaceState(null, '', url); } catch (e) { /* file:// o cross-origin */ }
    }

    function openFromHash() {
      var match = /^#pezzo-(.+)$/.exec(location.hash);
      if (!match) return;
      // decodeURIComponent lancia URIError su percentuali malformate (#pezzo-100%):
      // senza catch l'eccezione uscirebbe da initSection e fermerebbe le sezioni dopo.
      var slug;
      try { slug = decodeURIComponent(match[1]); } catch (e) { slug = match[1]; }
      var target = null;
      Array.prototype.forEach.call(section.querySelectorAll('[data-commission]'), function (btn) {
        if (!target && btn.getAttribute('data-slug') === slug) target = btn;
      });
      if (target) open(target);
    }

    function onKey(e) {
      switch (e.key) {
        case 'Escape': close(); break;
        case 'ArrowLeft': go(-1); break;
        case 'ArrowRight': go(1); break;
        case 'Tab': trapFocus(e); break;
      }
    }

    function trapFocus(e) {
      var focusables = Array.prototype.slice
        .call(lb.querySelectorAll('button, a[href]'))
        .filter(function (el) { return !el.hidden && el.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (!lb.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
        return;
      }
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    var touchX = null;
    lb.addEventListener('touchstart', function (e) {
      touchX = e.changedTouches[0].clientX;
    }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      touchX = null;
    }, { passive: true });

    // Apertura dai pezzi
    Array.prototype.forEach.call(
      section.querySelectorAll('[data-commission]'),
      function (btn) {
        btn.addEventListener('click', function () { open(btn); });
      }
    );

    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });
    closeBtn.addEventListener('click', close);
    lb.addEventListener('click', function (e) {
      if (e.target === lb) close(); // click sul backdrop
    });

    openFromHash();
  }

  /**
   * Filtri per tipo/materiale. Tutte le card sono già nel DOM: si nascondono e
   * basta, nessuna richiesta al server. I conteggi si aggiornano incrociando i
   * due gruppi, così una chip che porterebbe a zero risultati resta disabilitata.
   */
  function initFilters(section) {
    if (section.__commissionsFiltersInit) return;
    section.__commissionsFiltersInit = true;

    var bar = section.querySelector('[data-cfilters]');
    if (!bar) return;

    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-commission]'));
    var chips = Array.prototype.slice.call(bar.querySelectorAll('[data-cfilter]'));
    var emptyEl = section.querySelector('[data-cempty]');
    var state = { tipo: '', materiale: '' };

    function matches(card, dim, value) {
      return !value || card.getAttribute('data-' + dim) === value;
    }

    function countFor(dim, value) {
      var other = dim === 'tipo' ? 'materiale' : 'tipo';
      var n = 0;
      cards.forEach(function (card) {
        if (matches(card, dim, value) && matches(card, other, state[other])) n++;
      });
      return n;
    }

    function apply() {
      var visible = 0;
      cards.forEach(function (card) {
        var ok = matches(card, 'tipo', state.tipo) && matches(card, 'materiale', state.materiale);
        card.hidden = !ok;
        if (ok) visible++;
      });
      if (emptyEl) emptyEl.hidden = visible > 0;

      chips.forEach(function (chip) {
        var dim = chip.getAttribute('data-cfilter');
        var value = chip.getAttribute('data-value');
        var active = state[dim] === value;
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');

        var n = countFor(dim, value);
        var countEl = chip.querySelector('[data-ccount]');
        if (countEl) countEl.textContent = value ? n : '';
        // mai disabilitare la chip attiva: resterebbe impossibile tornare indietro
        chip.disabled = !!value && n === 0 && !active;
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var dim = chip.getAttribute('data-cfilter');
        var value = chip.getAttribute('data-value');
        // Ri-cliccare la chip attiva la disattiva: si torna a "Tutti".
        state[dim] = state[dim] === value ? '' : value;
        apply();
      });
    });

    apply();
  }

  function initAll() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-commissions]'),
      function (section) {
        initFilters(section);
        initSection(section);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
